module.exports = __webpack_public_path__ + "img/mofid.0a47775.png";